import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import _ from "lodash";

const ToDoSummary = (props) => {
  return (
    <Row className="mt-4">
      <Col>
        <Card border="light" className="shadow dashboardStats">
          <Card.Body>
            <Row>
              <Col xs="6" sm="3">
                <div style={{ cursor: "pointer" }} title="View all Backlogs (Till date)" onClick={() => props.onFilter(1)}>
                  <span className="d-flex justify-content-center align-items-center">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/delayed.png`}
                      width="50"
                      height="50"
                      className="d-inline-block align-top me-2"
                      alt="Delayed"
                    />
                    <span className="title me-2">{_.get(props, "stats.backlog", "-")}</span>
                    <span>
                      <span className="d-block mb-2 subtitle">Backlog</span> <small>(Till date)</small>
                    </span>
                  </span>
                </div>
              </Col>
              <Col xs="6" sm="3">
                <div style={{ cursor: "pointer" }} title="View all Upcoming (Today)" onClick={() => props.onFilter(2)}>
                  <span className="d-flex justify-content-center align-items-center">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/upcoming.png`}
                      width="50"
                      height="50"
                      className="d-inline-block align-top me-2"
                      alt="Upcoming"
                    />
                    <span className="title me-2">{_.get(props, "stats.today", "-")}</span>
                    <span>
                      <span className="d-block mb-2 subtitle">Due today</span>
                      <small>(Today)</small>
                    </span>
                  </span>
                </div>
              </Col>
              <Col xs="6" sm="3">
                <div style={{ cursor: "pointer" }} title="View all Complete (This Week)" onClick={() => props.onFilter(3)}>
                  <span className="d-flex justify-content-center align-items-center">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/completed.png`}
                      width="50"
                      height="50"
                      className="d-inline-block align-top me-2"
                      alt="Completed"
                    />
                    <span className="title me-2">{_.get(props, "stats.completed", "-")}</span>
                    <span>
                      <span className="d-block mb-2 subtitle">Complete</span>
                      <small>(This Week)</small>
                    </span>
                  </span>
                </div>
              </Col>
              <Col xs="6" sm="3">
                <div style={{ cursor: "pointer" }} title="View all Upcoming (30 Days)" onClick={() => props.onFilter(4)}>
                  <span className="d-flex justify-content-center align-items-center">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/upcoming30days.png`}
                      width="50"
                      height="50"
                      className="d-inline-block align-top me-2"
                      alt="Upcoming 30 Days"
                    />
                    <span className="title me-2">{_.get(props, "stats.upcoming30days", "0")}</span>
                    <span>
                      <span className="d-block mb-2 subtitle">Upcoming</span>
                      <small>(30 Days)</small>
                    </span>
                  </span>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default ToDoSummary;
